import React from "react";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "@components/common/Header/Header";
import LiveChatIcon from "@styles/all-images/icons/dashboard-icons/live-chat.svg";
import TodoIcon from "@styles/all-images/icons/dashboard-icons/to-do-list.svg";
import CalendarIcon from "@styles/all-images/icons/dashboard-icons/calender.svg";
import ContactsIcon from "@styles/all-images/icons/dashboard-icons/contacts.svg";
import DocumentIcon from "@styles/all-images/icons/dashboard-icons/document.svg";
import SignIcon from "@styles/all-images/icons/dashboard-icons/sign.svg";
import ClientOnboardingIcon from "@styles/all-images/icons/dashboard-icons/client.svg";
import SupplierOnboardingIcon from "@styles/all-images/icons/dashboard-icons/supplier.svg";
import CRMIcon from "@styles/all-images/icons/dashboard-icons/crm.svg";
import AppointmentsIcon from "@styles/all-images/icons/dashboard-icons/apppointment.svg";
import QuotesIcon from "@styles/all-images/icons/dashboard-icons/quotes.svg";
import ClientFacilityIcon from "@styles/all-images/icons/dashboard-icons/sign.svg";
import AccountingIcon from "@styles/all-images/icons/dashboard-icons/accounting.svg";
import ManagementIcon from "@styles/all-images/icons/dashboard-icons/management-accounts.svg";
import FuelOrdersIcon from "@styles/all-images/icons/dashboard-icons/sign.svg";
import StockPurchasesIcon from "@styles/all-images/icons/dashboard-icons/stock-purchase.svg";
import StockManagementIcon from "@styles/all-images/icons/dashboard-icons/stock-inventory.svg";
import ReportsIcon from "@styles/all-images/icons/dashboard-icons/reports.svg";
import FinanceCovenantIcon from "@styles/all-images/icons/dashboard-icons/finance-covenant.svg";
import StaffManagementIcon from "@styles/all-images/icons/dashboard-icons/staff-management.svg";
import UserManagementIcon from "@styles/all-images/icons/dashboard-icons/user-management.svg";
import GeneralMasterIcon from "@styles/all-images/icons/dashboard-icons/general-masters.svg";
import RolesPermissionsIcon from "@styles/all-images/icons/dashboard-icons/roles-permissions.svg";
import CMSPageIcon from "@styles/all-images/icons/dashboard-icons/CMS-page.svg";
import ProfileManagementIcon from "@styles/all-images/icons/dashboard-icons/profile-management.svg";
import TierConfigurationIcon from "@styles/all-images/icons/dashboard-icons/tier-configuration.svg";
import AvatarIcon from "@styles/all-images/icons/dashboard-icons/avatar.svg";
import PhoneIcon from "@styles/all-images/icons/dashboard-icons/phone-icon.svg";
import EmailIcon from "@styles/all-images/icons/dashboard-icons/email-icon.svg";
import RoleIcon from "@styles/all-images/icons/dashboard-icons/role-icon.svg";
import LinkIcon from "@styles/all-images/icons/dashboard-icons/link-icon.svg";

const Dashboard = () => {
  const navigate = useNavigate();
  const menuItems = [
    { icon: LiveChatIcon, title: "Live Chat", link: "/live-chat" },
    { icon: TodoIcon, title: "To Do", link: "/to-do" },
    { icon: CalendarIcon, title: "Calendar", link: "/calendar" },
    { icon: ContactsIcon, title: "Contacts", link: "/contacts" },
    { icon: DocumentIcon, title: "Document", link: "/document" },
    { icon: SignIcon, title: "Sign", link: "/sign" },
    {
      icon: ClientOnboardingIcon,
      title: "Client\nOn-boarding",
      link: "/client-onboarding",
    },
    {
      icon: SupplierOnboardingIcon,
      title: "Supplier\nOn-boarding",
      link: "/supplier-onboarding",
    },
    { icon: CRMIcon, title: "CRM", link: "/crm" },
    { icon: AppointmentsIcon, title: "Appointments", link: "/appointments" },
    { icon: QuotesIcon, title: "Quotes", link: "/quotes" },
    {
      icon: ClientFacilityIcon,
      title: "Client Facility\nTrades",
      link: "/client-facility",
    },
    { icon: AccountingIcon, title: "Accounting", link: "/accounting" },
    {
      icon: ManagementIcon,
      title: "Management\nAccounts",
      link: "/management",
    },
    {
      icon: FuelOrdersIcon,
      title: "CDD/PPC\nFuel Orders",
      link: "/fuel-orders",
    },
    {
      icon: StockPurchasesIcon,
      title: "Stock\nPurchases",
      link: "/stock-purchases",
    },
    {
      icon: StockManagementIcon,
      title: "Stock\nManagement",
      link: "/stock-management",
    },
    { icon: ReportsIcon, title: "Reports", link: "/reports" },
    {
      icon: FinanceCovenantIcon,
      title: "Finance Covenant",
      link: "/finance-covenant",
    },
    {
      icon: StaffManagementIcon,
      title: "Staff Management",
      link: "/staff-management",
    },
    {
      icon: UserManagementIcon,
      title: "User Management",
      link: "/user-management",
    },
    {
      icon: GeneralMasterIcon,
      title: "General Master",
      link: "/general-masters/commodity",
    },
    {
      icon: RolesPermissionsIcon,
      title: "Roles & Permissions",
      link: "/roles-and-permissions",
    },
    {
      icon: ProfileManagementIcon,
      title: "Profile Management",
      link: "/profile-management",
    },
    {
      icon: TierConfigurationIcon,
      title: "Tier Configuration",
      link: "/tier-configuration",
    },
    { icon: CMSPageIcon, title: "CMS Page", link: "/cms-page" },
  ];

  return (
    <div className="tw-pb-10">
      <HeaderComponent />

      <div className="tw-container-fluid tw-mx-auto tw-mt-[110px] tw-px-8">
        <div className="tw-flex tw-flex-wrap tw-justify-between">
          <div className="sm:tw-w-4/5 tw-w-full tw-px-28">
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-6 md:tw-grid-cols-3 sm:tw-grid-cols-2 tw-gap-5">
              {menuItems.map((item, index) => (
                <div key={index}>
                  <button
                    onClick={() => navigate(item.link)}
                    className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-[#E9EAEB] dashboard-box-shadow tw-h-[150px] md:tw-h-[110px] tw-w-[150px] md:tw-w-[110px] tw-mb-4"
                  >
                    <div className="tw-flex tw-items-center tw-justify-center">
                      <img
                        src={item.icon}
                        alt={item.title}
                        className="tw-w-[53px] tw-h-[53px] tw-object-contain"
                      />
                    </div>
                  </button>
                  <div className="tw-text-center tw-w-[150px] md:tw-w-[110px]">
                    <button
                      className="font-size-base tw-text-center tw-font-semibold font-primary font-primary-color tw-leading-5 tw-bg-transparent tw-border-0"
                      onClick={() => navigate(item.link)}
                    >
                      {item.title}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="sm:tw-w-1/5 tw-w-full tw-flex tw-justify-end">
            <div className="tw-fixed tw-bg-white tw-border tw-rounded-md tw-border-[#E9EAEB] tw-w-[290px] tw-h-[620px] tw-z-10">
              <div className="tw-p-6 tw-flex tw-flex-col tw-gap-6">
                {/* Profile Section */}
                <div className="tw-flex tw-flex-col">
                  <div className="tw-flex tw-items-center tw-flex-col tw-gap-3 tw-mb-4">
                    <div className="tw-w-10 tw-h-10 tw-border tw-rounded-[10px] tw-flex tw-items-center tw-justify-center">
                      <img
                        src={AvatarIcon}
                        alt="Avatar"
                        className="tw-w-6 tw-h-6"
                      />
                    </div>
                    <h2 className="tw-text-[16px] tw-font-semibold font-primary font-primary-color tw-leading-5">
                      Elijah Adebayo
                    </h2>
                  </div>
                  <div className="tw-flex tw-flex-col tw-gap-2">
                    <div className="tw-flex tw-items-center tw-gap-2">
                      <a
                        href="tel:+27471547804"
                        className="tw-text-[15px] tw-text-[#717680] tw-flex tw-items-center tw-gap-2"
                      >
                        <img
                          src={PhoneIcon}
                          alt="Phone"
                          className="tw-w-5 tw-h-5"
                        />
                        +27 471 54 78 04
                      </a>
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-2">
                      <a
                        href="mailto:elijah@ibanqtechnology.com"
                        className="tw-text-[15px] tw-text-[#717680] tw-flex tw-items-center tw-gap-2"
                      >
                        <img
                          src={EmailIcon}
                          alt="Email"
                          className="tw-w-5 tw-h-5"
                        />
                        elijah@ibanqtechnology.com
                      </a>
                    </div>
                  </div>
                </div>

                {/* Company Details */}
                <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-12">
                  <h2 className="tw-text-[16px] tw-font-semibold tw-border-b tw-pb-2">
                    Company Details
                  </h2>
                  <div className="tw-flex tw-flex-col tw-gap-2">
                    <h3 className="tw-text-[15px] tw-font-medium font-primary font-primary-color tw-leading-5">
                      iBanq
                    </h3>
                    <div className="tw-flex tw-flex-col tw-gap-2">
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <a
                          href="tel:+27211234567"
                          className="tw-text-[15px] tw-text-[#717680] tw-flex tw-items-center tw-gap-2 tw-cursor-pointer"
                        >
                          <img
                            src={PhoneIcon}
                            alt="Phone"
                            className="tw-w-5 tw-h-5"
                          />
                          +27 211 23 45 67
                        </a>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <a
                          href="mailto:ibanq@ibanqtechnology.com"
                          className="tw-text-[15px] tw-text-[#717680] tw-flex tw-items-center tw-gap-2 tw-cursor-pointer"
                        >
                          <img
                            src={EmailIcon}
                            alt="Email"
                            className="tw-w-5 tw-h-5"
                          />
                          ibanq@ibanqtechnology.com
                        </a>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <a
                          href="/"
                          className="tw-text-[15px] tw-text-[#717680] tw-flex tw-items-center tw-gap-2 tw-cursor-pointer"
                        >
                          <img
                            src={RoleIcon}
                            alt="User"
                            className="tw-w-5 tw-h-5"
                          />
                          Operational User
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Useful Links */}
                <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-12">
                  <h2 className="tw-text-[15px] tw-font-semibold tw-border-b tw-pb-2">
                    Useful Link
                  </h2>
                  <div className="tw-flex tw-flex-col tw-gap-2">
                    <a
                      href="/"
                      className="tw-text-[15px] tw-text-[#146C94] tw-flex tw-items-center tw-gap-2"
                    >
                      <img
                        src={LinkIcon}
                        alt="Link"
                        className="tw-w-5 tw-h-5"
                      />
                      Add Team Members
                    </a>
                    <a
                      href="/"
                      className="tw-text-[15px] tw-text-[#146C94] tw-flex tw-items-center tw-gap-2"
                    >
                      <img
                        src={LinkIcon}
                        alt="Link"
                        className="tw-w-5 tw-h-5"
                      />
                      Documents Approval
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Sidebar */}
    </div>
  );
};

export default Dashboard;
